class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.desktopMediaQuery = window.matchMedia('(min-width: 990px)');
    this._hoverOpen = this._hoverOpen.bind(this);
    this._hoverClose = this._hoverClose.bind(this);
    this._summaryClick = this._summaryClick.bind(this);
    this._onMediaChange = this._onMediaChange.bind(this);
    this.desktopMediaQuery.addEventListener('change', this._onMediaChange);
    this._applyHoverBehavior(this.desktopMediaQuery.matches);

    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary?.querySelector('.header__menu-item-link')) {
      summary.addEventListener('click', this._summaryClick);
    }
  }

  _summaryClick(event) {
    const link = event.currentTarget.querySelector('.header__menu-item-link');
    if (!link?.href) return;

    event.preventDefault();

    if (event.metaKey || event.ctrlKey || event.shiftKey) {
      window.open(link.href, event.shiftKey ? '_blank' : link.target || '_blank');
      return;
    }

    window.location.assign(link.href);
  }

  _applyHoverBehavior(isDesktop) {
    if (isDesktop) {
      this.addEventListener('mouseenter', this._hoverOpen);
      this.addEventListener('mouseleave', this._hoverClose);
    } else {
      this.removeEventListener('mouseenter', this._hoverOpen);
      this.removeEventListener('mouseleave', this._hoverClose);
    }
  }

  _onMediaChange(e) {
    this.close();
    this._applyHoverBehavior(e.matches);
  }

  _hoverOpen() {
    clearTimeout(this._closeTimer);
    this.mainDetailsToggle.setAttribute('open', '');
  }

  _hoverClose() {
    this._closeTimer = setTimeout(() => this.close(), 100);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
